<template>
  <div class="params-ship-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="upload" size="mini" class="upload"
                     type="primary" icon="el-icon-upload2"><span>上传整船平面图</span>
            <input class="file" name="blobup_file"
                   type="file" multiple
                   accept="image/png,image/jpeg,image/gif,image/jpg"
                   @change="upload"/>
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15" style="min-height:400px;">
      <div v-if="ship_img.url">
        <v-ship-map-drawline :ship_img="ship_img"></v-ship-map-drawline>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import {api} from '../../common/js/api.js';
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  import ShipMapDrawline from '../../components/ship-map-drawline.vue';
  export default {
    data() {
      return {
        ship_img: {
          url: '',
          width: 0,
          height: 0
        }
      }
    },

    computed: {},

    created() {
      this.getData();
    },

    mounted(){
    },

    methods: {
      upload(){
        let file = document.getElementsByName('blobup_file')[0].files[0];
        console.log(file);
        if (file) {
          let formData = new FormData();
          formData.append('file', file);
          api.upload.upload(formData).then((res) => {
//            console.log(res.data.file.file);
//            console.log(res.data.file.id);
//            api.upload.getFileById(res.data.file.id).then((res2) => {
//              console.log(res2);
//            })
          });
        }

        tool.setCookie('ship_image', '../common/images/ship2.jpg');
        this.getData();
      },
      getData(){
        if (tool.getCookie('ship_image')) {
          this.ship_img.width = 5000;
          this.ship_img.height = 1815;
          this.ship_img.url = '1111';
        }
      },
    },

    components: {
      'v-ship-map-drawline': ShipMapDrawline,
    }
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import "../../common/less/ship-map.less";

  .params-ship-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .upload {
      position: relative;
      .file {
        position: absolute;
        left: 0;
        top: 0;
        width: 200%;
        height: 100%;
        z-index: 999;
        opacity: 0;
      }
    }
  }

</style>
